export default function ($http) {
    return function (vehicleId) {
        return $http.get(`api/vehicles/${vehicleId}`)
            .then(result => result.data.result)
            .then(x => ({
                details: x,
                mileages: x.mileage,
                keepers: x.keepers,
                dealers: x.dealers,
                enquiries: x.enquiries,
                discrepancies: x.discrepancies,
                previousVrms: x.previousVrms,
                histories: x.history
            }));
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/vehicles/getVehicle.js